import React, { Component } from 'react';
import InternetBankingActions from '../actions/InternetBankingActions';
import envConfig from '../../static/config';

/**
 * Higher Order Component responsible for setting the default brandID from a
 * provided `envConfig` (As long as the brandId is not `"DYB"`).
 * Triggers `InternetBankingActions.setBrandId()` on mount if a valid `brandId`
 * is present.
 *
 * @todo Component currently takes in an entire `envConfig` object and passes it
 * through to the `WrappedComponent`. In the future, see if we can get away with
 * just taking in a `brandId` string. – Kraig Walker, 23/06/2021.
 */
export function DefaultBankSelector(WrappedComponent) {
  return class extends Component {
    componentDidMount() {
      const { brandId } = envConfig;

      // Set brandId if is CYB or VM
      if (brandId !== 'DYB') {
        InternetBankingActions.setBrandId(brandId);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
